module.exports = __webpack_public_path__ + "img/40200.63394742.jpg";